export const userName = {
    color: '$userInfoText',
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '10px',
    maxWidth: '220px',
    textAlign: 'center',
    variants: {mid: {true: {fontSize: '16px'}}},
}

export const userInfoViewWrapper = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    variants: {light: {true: {}}},
}

export const avatar = {
    display: 'flex',
    margin: '15px 0 30px 0',
    variants: {
        size: {
            big: {},
            mid: {marginBottom: '15px'},
        },
    },
}

export const info = {
    alignItems: 'center',
    color: '$userInfoInfoText',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '16px',
    marginBottom: '15px',
}

export const icon = {
    display: 'inline-block',
    marginLeft: '5px',
    variants: {
        badge: {
            true: {
                backgroundColor: '$userInfoBadgeBackground',
                borderRadius: '10px',
                boxSizing: 'border-box',
                color: '$userInfoBadge',
                height: '30px',
                marginBottom: '5px',
                padding: '5px',
                width: '30px',
            },
        },
    },
    width: '20px',
}

export const badges = {
    ' > div': {
        'alignItems': 'center',
        'display': 'flex',
        'flexDirection': 'column',
        'marginRight': '20px',
        // eslint-disable-next-line sort-keys
        '&:last-of-type': {marginRight: 0},
    },
    'display': 'flex',
    'justifyContent': 'center',
    'margin': '10px 0',
}

export const badgeTitle = {fontSize: '14px'}

export const actions = {
    button: {width: '100%'},
    marginTop: '10px',
    width: '100%',
}
